<template>
  <div class="main">
    <div class="logo">
      <van-image width="100" height="100" round :src="logo" />
      <p>正在跳转到{{ name }}小程序...</p>
    </div>
    <div class="btn">
      <p>如未自动提示打开请点击下方按钮</p>
      <van-button type="primary" @click="goWeixin">点击打开{{ name }}小程序</van-button>
    </div>
  </div>
</template>

<script>
import { generatescheme } from "@/api/common";
import qs from "qs";
export default {
  data() {
    return {
      name: "慕思会员",
      logo: "https://consumer.derucci.net/static/img/logo.c8d2606c.png",
    };
  },
  created() {
    if (this.$route.query.data) {
      try {
        const data = JSON.parse(decodeURIComponent(this.$route.query.data));
        this.name = data.name;
        this.logo = data.logo;
      } catch (e) {
        console.log(e);
        this.$dialog.alert({ message: "解析参数失败data必须为JSON字符串" });
      }
    }
    this.goWeixin();
  },
  methods: {
    goWeixin() {
      const path =
        this.$route.query.path || "pages/activity/activityNewYearGift";
      const params = { ...this.$route.query };
      if (params.targetPath?.includes("/pages/anniversary20th/indexPage?activityId=1792849782232637441")) delete params.activityId


      if (params.path) delete params.path;
      if (params.env) delete params.env;
      if (params.data) delete params.data;
      if (params.appId) delete params.appId;

      generatescheme({
        path,
        query: qs.stringify(params),
        envVersion: this.$route.query.env || "release",
        appId: this.$route.query.appId || "wx03527497c5369a2c",
      }).then((res) => {
        if (res.code == 0) {
          location.href = res.data;
        } else {
          this.$dialog.alert({ message: "获取小程序链接失败！" + res.msg });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  .logo {
    padding-top: 50px;
    text-align: center;

    p {
      font-size: 14px;
    }
  }

  .btn {
    text-align: center;
    padding-top: 200px;

    p {
      font-size: 14px;
      color: #999;
    }
  }
}
</style>
